module.exports = __webpack_public_path__ + "static/img/webAutismoyAlergias.2ef7c78.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/portfolioWeb/webAutismoyAlergias.webp
// module id = 487
// module chunks = 1